import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import DetailsSection from 'components/Booking/Bedbank/DetailsSection'
import { BaseImage } from 'components/Common/OrderView/styles'
import PaneDetailsSection from 'components/Common/Pane/PaneDetailsSection'
import SmallToggleButton from 'components/Luxkit/Button/SmallToggleButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import useToggle from 'hooks/useToggle'

interface Prop {
  offer: App.BedbankOffer
  order: App.Order
}

const StyledPaneDetailsSection = styled(PaneDetailsSection)`
  flex-basis: 100%;
`

const ReservedFor = styled.div`
  display: flex;
  flex-direction: column;
`

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.default.six};
`

const PackageDetails = styled(BookingDetails)``

function BedbankOfferPackageSummary({ offer, order }: Prop) {
  const { value: isShowingMoreDetails, toggle: toggleShowMoreDetails } =
    useToggle()

  const pkg = (
    orderBedbankRoom: App.OrderBedbankItem,
  ): App.BedbankPackage | undefined | false =>
    offer &&
    orderBedbankRoom &&
    offer?.packages &&
    offer.packages.length > 0 &&
    offer.packages.find((p) => p.roomId === orderBedbankRoom.roomTypeId)

  return (
    <>
      {order.bedbankItems.map((orderBedbankItem) => {
        return orderBedbankItem.rooms.map((orderBedbankRoom) => {
          const orderBedbankPackage = pkg(orderBedbankItem)

          const imageId =
            (orderBedbankPackage &&
              orderBedbankPackage.images &&
              orderBedbankPackage.images.length > 0 &&
              orderBedbankPackage.images[0].id) ??
            undefined

          return (
            orderBedbankRoom &&
            orderBedbankPackage && (
              <PackageDetails key={orderBedbankRoom.roomId}>
                <Heading variant="heading5">Your Package</Heading>
                {imageId && (
                  <BaseImage
                    className="hidden-print"
                    id={imageId}
                    mobileAspectRatio="9:4"
                    mobileWidth="100"
                  />
                )}
                {orderBedbankPackage.name && (
                  <div>
                    <BodyText variant="medium" weight="semi-bold">
                      {orderBedbankPackage.name}
                    </BodyText>
                  </div>
                )}
                {orderBedbankRoom && (
                  <ReservedFor>
                    <BodyText variant="medium" weight="semi-bold">
                      Reserved for
                    </BodyText>
                    {/* ToDo: Do this in a cleaner way */}
                    <BodyText variant="large">{`${orderBedbankRoom.guestFirstName} ${orderBedbankRoom.guestLastName}`}</BodyText>
                  </ReservedFor>
                )}
                {orderBedbankPackage && (
                  <>
                    <SmallToggleButton
                      on={isShowingMoreDetails}
                      onClick={toggleShowMoreDetails}
                    >
                      {isShowingMoreDetails ? 'Hide' : 'View'} package and room
                      details
                    </SmallToggleButton>
                    <StyledPaneDetailsSection
                      isOpen={isShowingMoreDetails}
                      onToggle={toggleShowMoreDetails}
                    >
                      <DetailsSection pkg={orderBedbankPackage} />
                    </StyledPaneDetailsSection>
                  </>
                )}
              </PackageDetails>
            )
          )
        })
      })}
    </>
  )
}

export default BedbankOfferPackageSummary
